import * as types from './actionTypes';
import createAxe from '../../middlewares/Axe'
import { omit, update } from 'lodash';
import { triggerError } from '../maintenanceActions';
import { cancelOperation } from '../authActions';
import goToVerse from '../../middlewares/Axe/elevator.js';
import { goLoading, outLoading } from '../loadingActions';
import { saveDBSell } from '../dbActions';
import { takePicture } from '../cameraActions';
import { setLightStat } from '../lightActions';

import { Loading as i18n, Errors as i18nErrors } from '../../middlewares/i18n';
import { setStage } from '../transactionActions';
import { setFirst, setLast, setPower, setRemaining } from '../clientActions';
import { setLocalState, setOperatorNmls } from '../machineActions/index.js';
import { setOldFee, setOldCharges, setSavings } from '../couponActions/index.js';
import { setBABusyFalse, getBillsNonce } from '../billAcceptorActions';
import { setCurrFees, setOldFees as setFeesOldFees } from '../feesActions';

export const TIERS = ['partial_telesign', 'telesign', 'id'];
export const BILLS = [1,2,5,10,20,50,100];

export function finishTx(){
  return function(dispatch){
    dispatch(cancelOperation(true))
    return dispatch({type: types.FINISH_TX})
  }
}

export function createBillString(bills){
  let billString = {
    'one': bills['1'].toString(),
    'two': bills['2'].toString(),
    'five': bills['5'].toString(),
    'ten': bills['10'].toString(),
    'twenty': bills['20'].toString(),
    'fifty': bills['50'].toString(),
    'one_hundred': bills['100'].toString()
  }
  return billString
}

// Send to wallet function
export function sendToWallet(){
  return function(dispatch, getState){
    // create a new stage 3.5 that is going to be "sending"
    // between stage 3 (insert cash) and stage 4 (receipt)
    // we prevent double noMoreBills
    dispatch(setStage(3.5))           // stage sending cash
    dispatch(takePicture('send_btc'))
    let lang = getState().i18n.language.current
    dispatch(goLoading(i18n[lang].sendingTx))
    dispatch(unlockExit())
    dispatch(stopAcceptingBills())           // Tell signalr not to get more bills
    // Prepare object purchase (purch) and ommit unnecesary values
    let purch = omit(getState().purchase, ['exit', 'message','bills', 'tiers', 'fee', 'address', 'tier', 'idMachine', 'flat', 'transactional', 'spotPrice', 'spread', 'quotedExchange']);
    //turn all numbers into strings
    for (var key in purch){
      if (typeof purch[key] === 'number'){
        update(purch, key, ()=>{
          return purch[key].toString()
        })
      }
    }
    //change bill format
    let billString = createBillString(getState().purchase['bills'])
    // FINAL REQUEST: same object purch but add the bills formatted
    // (this may change with new unity)
    let finalpurch = Object.assign({}, purch, {
      bills: billString
    })
    dispatch(saveDBSell(finalpurch))
    return dispatch(sendToBackend(finalpurch))
  }
}

export function sendToBackend(finalpurch){
  return async function(dispatch, getState){
    try{
      let axe = createAxe(getState())
      let res = await axe('/3971cc86b21c6924/v2/sale/finish-sale', {
        method: 'POST',
        headers: {
          'Atm-Token': `Bearer ${getState().machine.atm_id}`,
          'Session-Id': getState().purchase.idtx,
          'Customer-Token': `Bearer ${getState().client.client_id}`
        }
      })
      // Request good
      if(res.status === 200){
        goToVerse({ action: 'SELL_SENT', tx_id: getState().purchase.idtx })
        if(!finalpurch.manual) {                            // No manual (regular flow)
          if(res.data.data.first_name)
            dispatch(setFirst(res.data.data.first_name))
          if(res.data.data.last_name)
            dispatch(setLast(res.data.data.last_name))
          if(res.data.data.state)
            dispatch(setLocalState(res.data.data.state))
          if(res.data.data.nmls_id)
            dispatch(setOperatorNmls(res.data.data.nmls_id))
          if(res.data.data.disclaimer)
            dispatch(setReceiptDisclaimer(res.data.data.disclaimer))
          dispatch(setReceiptCustomerInfo(!!res.data.data.show_customer_info))  // false is a valid value. Always dispatch
          dispatch(setServerReceipt(res.data.data.receipt))  // The receipt screen prints it when present
          setTimeout(()=>{
            return dispatch(outLoading(res.data.data.direction))  // Follow direction backend
          }, 5000)
        }
        // else unnecesary because we did it in the background
      }
      // Failed request
      else{
        if(!finalpurch.manual)                                // No manual (regular flow)
          return dispatch(outLoading('receipt'))              // Force receipt
      }
    }
    // Any other error/fail during sending tx
    catch(error) {
      // 506 error code (duplicated tx)
      if(error.response && error.response.status === 506)
        goToVerse({ action: 'SELL_SENT', tx_id: getState().purchase.idtx })
      // any other error is a failed sale
      else{
        if(!finalpurch.manual)
          return dispatch(outLoading('receipt'))
        // else unnecesary because we did it in the background
      }
    }
  }
}

export function validateAddBills({ one = null, two = null, five = null, ten = null, twenty = null, fifty = null, one_hundred = null }) {
  return async function(dispatch, getState) {
    try {
      let axe = createAxe(getState())
      let nonce = getBillsNonce(getState())
      let res = await axe('/3971cc86b21c6924/v2/sale/validate-add-bills', {
        method: 'POST',
        headers: {
          'Atm-Token': `Bearer ${getState().machine.atm_id}`,
          'Session-Id': getState().purchase.idtx,
          'X-Bills-Nonce': nonce
        },
        data: {
          one: one,
          two: two,
          five: five,
          ten: ten,
          twenty: twenty,
          fifty: fifty,
          hundred: one_hundred
        }
      })
      if(res.status === 200) {
        return dispatch(stackBill())
      }
      else {
        return dispatch(returnBill())
      }
    }
    catch(error){
      const lang = getState().i18n.language.current
      const status = error.response && error.response.status
      if(status === 412) {
        dispatch(triggerError(i18nErrors[lang].belowMinLimit, 5000, () => {
          return dispatch(returnBill())
        }))
      }
      else if(status === 413) {
        dispatch(triggerError(i18nErrors[lang].billExceedsMax, 5000, () => {
          return dispatch(returnBill())
        }))
      }
      else if(status === 422) {
        dispatch(triggerError(i18nErrors[lang].maxLimitReached, 5000, () => {
          return dispatch(returnBill())
        }))
      }
      else if(status === 429) {
        dispatch(triggerError(i18nErrors[lang].dailyLimitExceeded, 5000, () => {
          return dispatch(returnBill())
        }))
      }
      else {
        return dispatch(returnBill())
      }
    }
  }
}

export function addBills(billData, retries = 2) {
  const { one = null, two = null, five = null, ten = null, twenty = null, fifty = null, one_hundred = null } = billData
  return async function(dispatch, getState) {
    let lang = getState().i18n.language.current
    try {
      let axe = createAxe(getState())
      let nonce = getBillsNonce(getState())
      let res = await axe('/3971cc86b21c6924/v2/sale/add-bills', {
        method: 'POST',
        headers: {
          'Atm-Token': `Bearer ${getState().machine.atm_id}`,
          'Session-Id': getState().purchase.idtx,
          'X-Bills-Nonce': nonce
        },
        data: {
          one: one,
          two: two,
          five: five,
          ten: ten,
          twenty: twenty,
          fifty: fifty,
          hundred: one_hundred
        }
      })
      if(res.status === 200) {
        return dispatch(addedBills(res))
      }
      else if(res.status === 204) {
        // duplicate request — nonce already processed, treat as success
        return
      }
      else {
        return dispatch(handleAddBillsFailure(billData, retries, lang))
      }
    }
    catch(error){
      if(error.response && error.response.status === 204) {
        return
      }
      return dispatch(handleAddBillsFailure(billData, retries, lang))
    }
  }
}

function handleAddBillsFailure(billData, retries, lang) {
  return function(dispatch) {
    if(retries > 0) {
      setTimeout(() => {
        dispatch(addBills(billData, retries - 1))
      }, 2000)
    } else {
      dispatch(setBABusyFalse())
      dispatch(triggerError(i18nErrors[lang].addBillsFailed))
      setTimeout(() => { return dispatch(sendToWallet()) }, 6500)
    }
  }
}

export function parseBillsObject(billValue){
  const map = {
    1: 'one',
    2: 'two',
    5: 'five',
    10: 'ten',
    20: 'twenty',
    50: 'fifty',
    100: 'one_hundred'
  };
  const key = map[billValue];
  if (!key) return {};
  return { [key]: 1 };
}

export function convertBillsObject(textBills){
  const map = {
    one: '1',
    two: '2',
    five: '5',
    ten: '10',
    twenty: '20',
    fifty: '50',
    one_hundred: '100'
  };
  const numericBills = {
    '1': 0,
    '2': 0,
    '5': 0,
    '10': 0,
    '20': 0,
    '50': 0,
    '100': 0
  };
  Object.entries(textBills || {}).forEach(([key, count])=>{
    const numKey = map[key];
    if(numKey) numericBills[numKey] = count;
  });
  return numericBills;
}

export function setOldFees(amount, totalFee){
  return function(dispatch, getState){
    let fees = getState().fees.old_fees
    if(!fees) return

    for(let i = 0; i < fees.length; i++){
      if(amount >= fees[i].min && amount <= fees[i].max){
        dispatch(setOldFee(fees[i].percent))
        let oldFeesCharged = (Math.floor((amount * parseFloat(fees[i].percent) / 100)*100))/100 + fees[i].flat;
        dispatch(setOldCharges(oldFeesCharged))
        dispatch(setSavings((oldFeesCharged - totalFee).toFixed(2)))
      }
    }
  }
}

export function addedBills(response){
  return function(dispatch, getState){
    const { total_inserted, fees, enviando, asset_amount, bills, used_power, remaining_power } = response.data
    const { fee_percentage, flat_fee_to_collect, percentage_fee_to_collect, total_collected_fees } = fees

    if(getState().purchase.num_bills){
      document.getElementById('continue-insert').classList.add('pulse');
      setTimeout(()=>document.getElementById('continue-insert').classList.remove('pulse'), 1000);
    }

    // Convert bills from text format to numeric format
    let numericBills = convertBillsObject(bills)
    let num_bills = Object.values(numericBills).reduce((a, b) => a + b, 0)
    let billString = createBillString(numericBills)

    // Calculate values from response
    let subtotal = total_inserted
    let totalFee = total_collected_fees
    let total = enviando
    let btc = asset_amount
    let fee = fee_percentage
    let flat = flat_fee_to_collect || 0

    // Handle coupon savings calculation
    if(getState().coupon.applied) {
      dispatch(setOldFees(subtotal, totalFee))
    }

    dispatch(setFee(fee))
    dispatch(setFlat(flat))
    dispatch(setPower(used_power))

    if(remaining_power !== undefined && remaining_power !== null) {
      dispatch(setRemaining(remaining_power))
    }

    dispatch(saveDBSell({ bills: billString, subtotal: subtotal, totalfee: totalFee, total: total, btc: btc, num_bills: num_bills, fee: fee }))
    goToVerse({ action: 'ADD_BILL', bills: numericBills, tx_id: getState().purchase.idtx })
    dispatch(fundsAdded(numericBills, subtotal, totalFee, total, btc, num_bills))
  }
}

export function setFlat(flat){
  return{
    type: types.SET_FLAT,
    flat
  }
}

export function setTimeSent(time){
  return function(dispatch){
    return dispatch({
      type: types.SET_TIME_SENT,
      time_sent: time
    })
  }
}

export function insertBill(){
  return function(dispatch, getState){
    if(getState().purchase.btcprice) {
      dispatch(setLightStat("BAS"))
      return dispatch({
        type: types.INSERT_BILL,
        signalR: true
      })
    }
    else {
      if(getState().purchase.subtotal > 0){
        return dispatch(noMoreBills())
      }
      else
        return dispatch(cancelOperation())
    }
  }
}

export function noMoreBills(){
  return function(dispatch){
    return dispatch(sendToWallet())
  }
}

export function stopAcceptingBills(){
  return{
    type: types.CANCEL_INS_BILL,
    signalR: true
  }
}

export function stackBill(){
  return{
    type: 'STACK_BILL',
    signalR: true
  }
}

export function fundsAdded(funds, subtotal, totalFee, total, btc, num_bills){
  return{
    type: types.FUNDS_ADDED,
    funds, subtotal, totalFee, total, btc, num_bills,
    signalR: true
  }
}

export function returnBill(message){
  return{
    type: types.RETURN_BILL,
    message,
    signalR: true
  }
}

export function printReceipt(content){
  return{
    type: types.PRINT_RECEIPT,
    content,
    signalR: true
  }
}

export function cancelInsBill(){
  return{
    type: types.CANCEL_INS_BILL,
    signalR: true
  }
}

export function lockPrice(){
  return async function(dispatch, getState){
    let lang = getState().i18n.language.current
    try {
      let axe = createAxe(getState())
      let res = await axe(`/3971cc86b21c6924/sale/${getState().purchase.idtx}/lock-rate`, {
        method: 'POST',
        headers: {
          'Customer-Token': `Bearer ${getState().client.client_id}`,
          'Atm-Token': `Bearer ${getState().machine.atm_id}`
        },
        data: {
          coin_type: "btc",
          fiat_type: "usd"
        }
      })
      if(res.status === 200) {
        let price = res.data.bitstop_rate
        dispatch(saveDBSell({ btcprice: price }))
        dispatch(lockedPrice(price))
        if(res.data.spot_rate)
          dispatch(lockedSpotPrice(res.data.spot_rate))
        if(res.data.spread)
          dispatch(setSpread(res.data.spread))
        if(res.data.quoted_exchange)
          dispatch(setQuotedExchange(res.data.quoted_exchange))
        return dispatch(insertBill())
      }
      else {
        dispatch(triggerError(i18nErrors[lang].tryLater))
        setTimeout(()=>{return dispatch(cancelOperation())}, 4700)
      }
    }
    catch(error){
      dispatch(triggerError(i18nErrors[lang].tryLater))
      setTimeout(()=>{return dispatch(cancelOperation())}, 4700)
    }
  }
}

export function lockPriceV2(){
  return async function(dispatch, getState){
    let lang = getState().i18n.language.current
    try {
      let axe = createAxe(getState())
      let res = await axe(`/3971cc86b21c6924/v2/sale/${getState().purchase.idtx}/lock-rate`, {
        method: 'POST',
        headers: {
          'Customer-Token': `Bearer ${getState().client.client_id}`,
          'Atm-Token': `Bearer ${getState().machine.atm_id}`
        },
        data: {
          coin_id: getState().multicrypto.coin.id,
          fiat_type: "usd"
        }
      })
      if(res.status === 200) {
        let price = res.data.bitstop_rate
        dispatch(setCurrFees(res.data.fees))
        dispatch(saveDBSell({ btcprice: price }))
        dispatch(lockedPrice(price))
        if(res.data.old_fees)
          dispatch(setFeesOldFees(res.data.old_fees))
        if(res.data.spot_rate)
          dispatch(lockedSpotPrice(res.data.spot_rate))
        if(res.data.spread)
          dispatch(setSpread(res.data.spread))
        if(res.data.quoted_exchange)
          dispatch(setQuotedExchange(res.data.quoted_exchange))
        return dispatch(insertBill())
      }
      else {
        dispatch(triggerError(i18nErrors[lang].tryLater))
        setTimeout(()=>{return dispatch(cancelOperation())}, 4700)
      }
    }
    catch(error){
      dispatch(triggerError(i18nErrors[lang].tryLater))
      setTimeout(()=>{return dispatch(cancelOperation())}, 4700)
    }
  }
}

export function lockedPrice(btcPrice){
  return{
    type: types.LOCK_PRICE,
    btcPrice
  }
}

export function lockedSpotPrice(spotPrice){
  return{
    type: types.LOCK_SPOT_PRICE,
    spotPrice
  }
}

export function setQuotedExchange(quotedExchange){
  return{
    type: types.SET_QUOTED_EXCHANGE,
    quotedExchange
  }
}

export function setSpread(spread){
  return{
    type: types.SET_SPREAD,
    spread
  }
}

export function lockExit(){
  return{
    type: types.LOCK_EXIT
  }
}

export function unlockExit(){
  return{
    type: types.UNLOCK_EXIT
  }
}

export function setIdTx(id){
  return{
    type: types.SET_ID_TX,
    idTx: id
  }
}

export function setFee(fee){
  return{
    type: types.SET_FEE,
    fee
  }
}

export function setDate(date){
  return{
    type: types.SET_DATE,
    date
  }
}

export function getPurchaseReceipt(){
  return async function(dispatch, getState){
    let axe = createAxe(getState());
    try {
      let {status, data: { data }} = await axe(`/athena/v2/Sale/${ getState().purchase.idtx }/receipt`, { method: 'GET' });
      if (status !== 200 || !data || !data.fiat) {
        console.log(`${Date(Date.now())} - Failed fetching purchase receipt, status: ${status}`)
        return;
      }
      let purchaseReceipt = {
        subtotal : data.fiat,
        totalfee : data.fee,
        total : data.enviando,
        btc : data.btc,
        address: data.address,
        spotPrice: data.rate.spot_rate,
        spread: data.rate.spread,
        quotedExchange: data.rate.quoted_exchange
      }
      dispatch(setPurchaseReceipt(purchaseReceipt));
    } catch (error) {
      console.log(`${Date(Date.now())} - Error fetching purchase receipt:`, error);
    }
  }
}

export function setPurchaseReceipt(purchaseReceipt){
  return {
    type: types.SET_PURCHASE_RECEIPT,
    purchaseReceipt
  }
}

export function setReceiptDisclaimer(receiptDisclaimer){
  return{
    type: types.SET_RECEIPT_DISCLAIMER,
    receiptDisclaimer
  }
}

export function setReceiptCustomerInfo(showCustomerInfoOnReceipt){
  return{
    type: types.SET_RECEIPT_CUSTOMER_INFO,
    showCustomerInfoOnReceipt
  }
}

export function setServerReceipt(serverReceipt){
  return{
    type: types.SET_SERVER_RECEIPT,
    serverReceipt
  }
}

export function setAssetType(assetType){
  return{
    type: types.SET_ASSET_TYPE,
    assetType
  }
}
